import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=18ed0aea&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ed0aea')) {
      api.createRecord('18ed0aea', component.options)
    } else {
      api.reload('18ed0aea', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=18ed0aea&", function () {
      api.rerender('18ed0aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HeOgiPoUEP4q/JS/comp/FavElement.vue"
export default component.exports